import React from 'react';
import type { UuidApiResponse } from '@/app/api/uuid/route';
import { useVariousFetch } from '@/shared/hooks/useVariousFetcher';

type UseUuid = {
  uuid: string;
  isReady: boolean;
};

export function useUuid(): UseUuid {
  const [uuid, setUuid] = React.useState<string>('');
  const [isReady, setIsReady] = React.useState<boolean>(false);
  const { fetcher } = useVariousFetch<UuidApiResponse>();

  React.useEffect(() => {
    fetcher('/api/uuid', {
      method: 'POST',
      credentials: 'include',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(({ result, data }) => {
        if (!result) {
          return;
        }

        setUuid(data.uuid);
      })
      .finally(() => {
        setIsReady(true);
      });
  }, [fetcher]);

  return {
    uuid,
    isReady,
  };
}
